import React from "react";
import DatePicker, { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import ja from "date-fns/locale/ja";

registerLocale("ja", ja);

const CustomHeader = ({ date, decreaseMonth, increaseMonth, prevMonthButtonDisabled, nextMonthButtonDisabled }) => {
  return (
    <div className="react-datepicker__header">
      <button onClick={decreaseMonth} disabled={prevMonthButtonDisabled} type="button" className="react-datepicker__navigation react-datepicker__navigation--previous" aria-label="Previous Month">
        <span className="react-datepicker__navigation-icon react-datepicker__navigation-icon--previous">Previous Month</span>
      </button>
      <span className="react-datepicker__current-month" style={{ fontWeight: "bold", fontSize: "0.944rem" }}>
        {`${date.getFullYear()}年 ${date.getMonth() + 1}月`}
      </span>
      <button onClick={increaseMonth} disabled={nextMonthButtonDisabled} type="button" className="react-datepicker__navigation react-datepicker__navigation--next" aria-label="Next Month">
        <span className="react-datepicker__navigation-icon react-datepicker__navigation-icon--next">Next Month</span>
      </button>
    </div>
  );
};

const CustomDatePicker = ({ selectedDateTime, onChange, showTimeSelect = true }) => {
  return (
    <div style={{ display: "flex", alignItems: "center", position: "relative" }}>
      <DatePicker
        selected={new Date(selectedDateTime)}
        onChange={onChange}
        showTimeSelect={showTimeSelect}
        timeFormat="HH:mm"
        timeIntervals={10}
        maxDate={new Date()}
        dateFormat={showTimeSelect ? "yyyy/MM/dd HH:mm" : "yyyy/MM/dd"}
        locale="ja"
        todayButton={"今日"}
        calendarStartDay={1}
        showIcon
        icon={
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#666" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" xmlns="http://www.w3.org/2000/svg">
            <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
            <line x1="16" y1="2" x2="16" y2="6"></line>
            <line x1="8" y1="2" x2="8" y2="6"></line>
            <line x1="3" y1="10" x2="21" y2="10"></line>
          </svg>
        }
        renderCustomHeader={(props) => <CustomHeader {...props} />}
      />
      <style>{`
        .react-datepicker-wrapper {
          width: auto;
        }
        .react-datepicker__view-calendar-icon input {
          padding: 0.5rem 0.75rem 0.5rem 40px;
          border-radius: 0.25rem;
          border: 1px solid #ccc;
          font-size: 0.875rem;
          height: 35px;
          width: ${showTimeSelect ? '170px' : '130px'};
          outline: none;
        }
        .react-datepicker__view-calendar-icon input:focus {
          border-color: #0a3d71;
          box-shadow: 0 0 0 2px rgba(10, 61, 113, 0.2);
        }
        .react-datepicker__calendar-icon {
          position: absolute;
          left: 10px !important;
          right: auto !important;
          top: 50% !important;
          transform: translateY(-50%);
          padding: 0 !important;
          width: 20px !important;
          height: 20px !important;
          pointer-events: none;
          fill: none;
        }
      `}</style>
    </div>
  );
};

export default CustomDatePicker;
